import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useProceduresCatalog() {
  const navigate = useNavigate();

  const [proceduresCatalog, setProceduresCatalog] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProceduresCatalog = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/procedures-catalog', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setProceduresCatalog(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchProceduresCatalog();
  }, [fetchProceduresCatalog]);

  return { proceduresCatalog, isLoading, error, refetch: fetchProceduresCatalog };
}
